import React from 'react';
import { Alert, Box } from '@mui/material';

export default function LicencaAvisoBanner({ mensagem, bloqueioProgramadoEm }) {
  if (!mensagem) return null;

  const quando = bloqueioProgramadoEm
    ? new Date(bloqueioProgramadoEm).toLocaleString('pt-BR')
    : null;

  return (
    <Box sx={{ px: { xs: 1, md: 0 }, pt: 1 }}>
      <Alert severity="warning" variant="filled" sx={{ borderRadius: 2 }}>
        <strong>Atenção — bloqueio programado</strong>
        {quando ? ` (${quando})` : ''}
        <br />
        {mensagem}
      </Alert>
    </Box>
  );
}
